const PHONE_NUMBER_ERROR =
  'Mobile number must be at least 10 digits and contain only numbers';

const signupStrings = {
  createAccount: {
    bankTitle: 'Your Bank.',
    yourRulesTitle: 'Your Rules.',
    description:
      'Enter the phone number and email you’ll use for your Varo Bank Account.',
    emailField: 'Email',
    uSMobileNumberField: 'US mobile number',
    passwordField: 'Create password',
    footer: 'By tapping "Open an account," I agree to the',
    agreementText: ' Telephone Use Agreement & Disclosures',
    footerEnd:
      ', and consent to have Varo send account-related message to this number.',
    buttons: {
      next: 'Next',
      joinToday: 'Open an account',
    },
    referral: {
      title: ' has invited you to join Varo!',
      heading: 'Referral code',
      invalidCode:
        'This bonus is no longer active. You can still apply for a Bank Account with no monthly fees or minimum balance.',
    },
    header: {
      organicHeaderImageLabel:
        'The Varo app home screen shown next to a Varo debit card',
      variantHeaderImageLabel:
        'A phone showing the Varo app next to a Varo debit card',
      headerIllustrationLabel: 'Varo illustration',
      variantAHeader: 'OPEN YOUR FREE BANK ACCOUNT',
      variantASubhead:
        'From everyday free banking* to cash advances, early payday, and credit building—it starts here.',
      variantBHeader: 'EVERYTHING YOU NEED IN A BANK.',
      variantBSubhead:
        'From free banking* to cash advances, early payday, and credit building—it starts here.',
      variantCHeader: 'A BANK ACCOUNT YOU CAN TRUST',
      variantCSubhead:
        'Give your money the confidence and security it deserves with Varo, a nationally chartered bank.',
      variantDHeader: 'CASH WHEN YOU NEED IT',
      variantDSubhead:
        'Access cash advances to cover unexpected expenses with a free Varo Bank Account*. Quals apply.',
      variantDisclosure: '*Loans and optional services have fees.',
      variantDescription:
        'Create a login for your new Varo Bank Account. Apply in less than 2 minutes today!',
    },
    attribution: {
      controlVariantHeader: 'Your bank.\nYour rules.',
      letGetStarted: 'Let’s get started.',
      setUpFuture: 'Set up your future.',
      betterBanking: 'Start banking better today.',
      joinBank:
        'Join the bank with sky-high savings, easy credit building, and affordable cash advances. ',
      joinHappyCustomer: 'Join our millions of happy customers.',
      newKindOfBank: "You're on your way to a new kind of bank.",
      signUpForVaro: 'Sign up for a Varo bank account.',
      joinMillion:
        'Join the millions of Varo customers who are doing more with their money.',
      ownLife: 'own your money life.',
      justAmount: '{{amount}}. just like that.',
      titleJoin: 'SPEND $20.\n GET $25.',
      subTitleJoin: 'Get $25 when you spend $20 in your first 30 days.',
      makeMoney: 'Make your money do way more',
      timeToMake: 'time to make it happen.',
      skyHigh:
        'Join the bank with sky-high savings, easy credit building, and affordable cash advances.',
      betterBank: 'A better bank for a better you.',
      allBestMoney: 'All the best money tools. all in one place.',
      betterCredit: 'Better credit starts here.',
      saveFaster: 'Save more. Save faster.',
      bankBorrow: 'Bank and borrow the easy way.',
      getAhead: 'Get ahead with better credit. ',
      extraCash: 'Spot yourself some extra cash.',
      borrowEase: 'Borrow with Ease',
      saveDreamBigger: 'Save faster. Dream bigger.',
    },
    varobank: 'Varo Bank, N.A. Member FDIC.',
    visaDisclosure:
      'The Varo Visa® Debit Card is issued by Varo Bank, N.A. pursuant to a license from Visa U.S.A. Inc and may be used everywhere Visa debit cards are accepted.',
    allRightReserved: '© {{year}} Varo Bank, N.A. All Rights Reserved.',
    seeFullTerms: '**See full terms',
    areaCodeValidationError: 'Enter a valid area code',
  },
  personalInfo: {
    title: 'Enter your legal name',
    textField: {
      firstName: 'First name',
      lastName: 'Last name',
    },
    buttons: {
      next: 'Next',
    },
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  dateOfBirth: {
    title: 'Enter your date of birth',
    subTitle: 'Date of birth',
    buttons: {
      next: 'Next',
    },
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  citizenship: {
    title: 'Are you a U.S. citizen?',
    description:
      'We have to ask, but you don’t need to be a US citizen to apply.',
    loading: 'Loading',
    citizen: 'I am a US citizen',
    noncitizen: 'I am not a US citizen',
    country: 'Country',
    search: 'Search',
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  employment: {
    loading: 'Loading',
    title: 'What do you do for work?',
    description:
      'As a bank, we’re required to ask. If your job’s not listed, pick the closest match. It won’t affect your application.',
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  ssnVerification: {
    title: 'Verify your identity',
    description:
      'Enter your social security number or individual taxpayer ID. This won’t impact your credit score.',
    textField: {
      ssn: 'SSN or ITIN',
    },
    buttons: {
      next: 'Next',
    },
    error: {
      required: 'Required',
      min9Char: '9 digits required',
    },
    infoMessage: 'Your information is encrypted and secured.',
    invalidSSN: 'Please enter a valid SSN',
  },
  legalAgreements: {
    title: "Let's review",
    review: 'Review',
    description:
      'You\u2019re almost there! Read and accept the terms below to send your application.',
    agreementTitle: 'Electronic Communications Agreement',
    agreementSubject:
      'This Electronic Communications Agreement (“Disclosure”) applies to all communications related to all current and future products issued or acquired by Varo Bank, N.A., and accompanying services available through varomoney.com (the “Website”) or mobile application (“Mobile App”). This Disclosure supplements and is to be construed in accordance with the terms of the agreement you received with any product you have signed up for at Varo Bank, N.A.\n\n“We”, “us”, “our”, refers to Varo Bank, N.A.. “You” and “your” mean the person identified on the products we offer. “Communication(s)” means any customer agreement or amendments thereto; disclosure; notice; response to claims; transaction history; privacy policy; and all other information related to the products and service Varo Bank, N.A. offers, including but not limited to information that we are required by law to provide you in writing. The products and services we offer are intended for use only by person(s) who are willing and able to receive notices and communications exclusively through the Website, the Mobile App or via electronic mail (“email”). If you do not agree to receive the legally-required notices and communications described herein in electronic and not paper form, then you may not open an account with us. Similarly, if after providing consent hereunder, you withdraw it, we reserve the right to close your account(s) and terminate your participation in the products we offer.',
    scopeOfCommunicationTitle:
      '1. Scope of communications to be provided in electronic form.',
    scopeOfCommunicationDescription:
      'When you use a product or service to which this Disclosure applies, you agree that any communications will be provided in electronic format, to the extent allowed by law, and that paper communications will not be sent. You consent to receive electronic communications and transactions includes, but is not limited to:',
    scopeOfCommunicationDescriptionOne:
      '\u2022 All legal and regulatory disclosures and communications associated with the Bank Account, Savings Account, Lending Account and any related products or services',
    scopeOfCommunicationDescriptionTwo:
      '\u2022 Statements for all accounts held by you at Varo Bank;',
    scopeOfCommunicationDescriptionThree:
      '\u2022 The Bank Account Agreement, Savings Account Agreement, Lending Account Agreement and any notices about changes in terms',
    scopeOfCommunicationDescriptionFour: '\u2022 Privacy policies and notices',
    scopeOfCommunicationDescriptionFive:
      '\u2022 Responses to claims filed in connection with the Bank Account, Savings Account, or Lending Account',
    scopeOfCommunicationDescriptionSix:
      '\u2022 Notices regarding insufficient funds or negative balances; and',
    scopeOfCommunicationDescriptionSeven:
      '\u2022 All other communications between us and Customer concerning the Bank Account, Savings Account, Lending Account and any related transactions, products or services',
    methodOfCommunication:
      '2. Method of providing communications in electronic form.',
    methodOfCommunicationDescription:
      'All communications that we provide in electronic form will be provided either (1) by email or (2) by access to the website, (3) through the mobile app, or (4) by short message service (“SMS”)',
    howToWithdraw: '3. How to withdraw consent.',
    howToWithdrawDescription:
      'You may withdraw consent to receive communications in electronic form by contacting us at 1-877-377-8276. If you withdraw consent, the Bank Account and Savings Account will be closed and a balance refund check may be issued in accordance with the terms of the Bank Account Agreement and the Savings Account Agreement. Any outstanding balances on your Lending Account will need to be repaid in accordance with their terms but no further advances or extensions will be permitted. If you withdraw consent, the legal validity and enforceability of prior communications delivered in electronic form will not be affected.',
    howToUpdate: '4. How to update records.',
    howToUpdateDescription:
      'It is your responsibility to provide us with a true, accurate and complete email address, phone number, and other information related to this Disclosure and the Bank Account, Savings Account, or Lending Account, and to maintain and update promptly any changes in this information. You can update information (such as the email address) in the App by contacting us at 1-877-377-8276. We are not responsible for any delay or failure in the receipt of the communications if we send the communications to the last email address you provided to us.',
    hardware: '5. Hardware and software requirements.',
    hardwareDescription:
      'In order to access, view, and retain electronic communications that we make available, you must have:',
    hardwareOne: '\u2022 An Apple iPhone running iOS version 13.0 or higher or',
    hardwareTwo:
      '\u2022 An Android device running Android OS 6.0 Marshmallow or above and access to the Google Play Store, or',
    hardwareThree:
      '\u2022 A personal computer capable of running one of these compatible browsers:',
    hardwareThreeA: '\u2022 Microsoft Edge version 81.0 or higher',
    hardwareThreeB:
      '\u2022 Firefox version 72 or higher; Safari version 13 or higher',
    hardwareThreeC: '\u2022 Chrome version 81 or higher, and',
    hardwareFour:
      '\u2022 Access to an active email account with an Email service provider.',
    hardwareFive:
      'We may update these requirements as necessary to preserve the ability to receive electronic communications. If there is a substantial change in these requirements, you will be notified of the changes accordingly.',
    paperCopy: '6. Requesting paper copies.',
    paperCopyDescription:
      'We will not send paper copies of any communication, however, we reserve the right, but assume no obligation, to provide a paper (instead of electronic) copy of any communication that you have authorized us to provide electronically. You can obtain a paper copy of an electronic communication by printing it or by requesting that we mail a paper copy. To request a paper copy, call us at 1-877-377-8276 during normal business hours.',
    communicationInWriting: '7. Communications in writing.',
    communicationInWritingDescription:
      'All communications in either electronic or paper format from us to you will be considered “in writing.” You should print or download a copy of this Disclosure and any other communications.',
    federalLaw: '8. Federal Law.',
    federalLawDescription:
      'You acknowledge and agree that consent to electronic communications is being provided in connection with a transaction affecting interstate commerce that is subject to the federal Electronic Signatures in Global and National Commerce Act (the “Act”), and that you and we both intend that the Act apply to the fullest extent possible to validate our mutual ability to conduct business by electronic means.',
    termination: '9. Termination/Changes.',
    terminationDescription:
      'We reserve the right, at our sole discretion, to discontinue the provision of electronic communications, or to terminate or change the terms and conditions upon which electronic communications are provided. We will provide you with notice of any such termination or change as required by law.',
    consent: '10. Consent.',
    consentDescription:
      'By checking “I agree,” in the App when you are presented with this disclosure, you adopt the checkmark as your electronic signature and you give us your affirmative consent to receive electronic communications as described herein. You further agree that your device satisfies the hardware and software requirements specified above and that you have provided us with your current email address to which we may send you electronic communications.',
    readAndAgree: "I've read and agreed to:",
    savingAccount: 'Varo Savings Account (optional)',
    electronicAgreement: 'Electronic Communication Agreement',
    ccpaNotice: 'CCPA Notice',
    mobilePrivacy: 'Varo’s Privacy Policies and Notices',
    and: ' and ',
    our: 'our ',
    includingOur: 'including our ',
    consumerPolicy: 'U.S. Consumer Privacy Notice',
    generalAgreement: 'General Terms Agreement',
    bankAgreement: 'Varo Bank Account Agreement & Disclosures',
    cashbackProgram: 'Cashback Program Addendum',
    eCBSV: 'eCBSV Agreement',
    ssaAgreementTitle:
      'Authorization for the Social Security Administration to Disclose Your Social Security Number Verification',
    ssaAgreementDescription:
      'I authorize the Social Security Administration (SSA) to verify and disclose to Varo Bank, N.A. through Socure Inc., their service provider, for the purpose of this transaction whether the name, Social Security Number (SSN), and date of birth I have submitted matches information in SSA records, including the basis for a no-match response. My consent is for a one-time validation within the next 90 days.',
    ssaAgreement:
      'By selecting “Apply”, you are signing the consent for SSA to disclose your SSN Verification to Varo Bank, N.A. and Socure Inc. You agree that your electronic signature has the same legal meaning, validity, and effect as your handwritten signature.',
    varoBankAccount: 'Varo Bank Account',
    agreeToAll: 'I agree to all',
    highYieldAccount:
      'I want to apply for a high-yield Varo Savings Account and agree to the ',
    savingAgreement: 'Savings Account Agreement',
    applyDisclosure:
      'By tapping on "Apply", I agree to Varo Bank Account Agreement & Disclosures and acknowledge the receipt of the U.S. Consumer Privacy Notice, CCPA Notice, and Varo Bank\u2019s U.S. Online & Mobile Privacy Policy.',
    apply: 'Apply',
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  declined: {
    title: 'Sorry, your application wasn’t approved.',
    description:
      'We couldn’t approve your application with the information provided.',
    close: 'Close',
  },
  approved: {
    title: 'Congrats, you’re approved!',
    description: 'Welcome to Varo! Start banking better today.',
    done: 'Done',
    successScreen: {
      congrats: 'Congrats!',
      title: 'You’re approved',
      description:
        'The Varo app makes it easy to get set up so you can start making the most out of your money.',
      listItems: {
        fees: 'Enjoy no monthly fees banking',
        payDay: 'Get up to 2 days early payday',
        borrow: 'Borrow cash when you need it',
      },
      button: 'Get the Varo app now',
    },
  },
  address: {
    header: 'Where should we send your card?',
    subHeader: 'Use your residential address. We can’t send to PO boxes.',
    textField: {
      addressLine1: 'Street address',
      addressLine2: 'Apt/Suite/Unit',
      city: 'City',
      state: 'State',
      zip: 'ZIP Code',
    },
    enterAddressManually: 'Enter address manually',
    buttons: {
      next: 'Next',
      editAddress: 'Edit address',
      done: 'Done',
    },
    validations: {
      suggested: 'Suggested',
      next: 'Next',
      whatYouEntered: 'What you entered',
      suggestedAddress: {
        header: 'We found a better address',
        subHeader: 'Review the suggested address below before proceeding.',
      },
      overRideAddress: {
        header: 'Confirm your address',
        subHeader:
          'Review the information below to make sure everything is correct.',
      },
      invalidAddress: {
        header: 'Double check your address',
        subHeader: '',
      },
    },
    title: 'Enter your address',
    inlineAlert: {
      errorTitle: 'Info failed to save. Please try again.',
    },
  },
  review: {
    title: 'Application Sent',
    description:
      'We typically take 3-5 business days to review your application. Check your email for updates.',
    logOut: 'Log out',
  },
  socure: {
    interstitial: {
      title: 'Verify your identity',
      subtitle:
        'This helps us keep your account safe and ensures no one else is trying to use it.',
      description:
        'After you complete verification, we may ask for additional documents. Check your email for more information.',
      button: 'Get started',
      logOut: 'Log out',
      viewPreviousAccountInfo: 'View previous account info',
      infoMessage: 'Your information is encrypted and secured.',
    },
    desktopVerify: {
      title: 'How to verify',
      subtitle:
        "Verification can only be done on a mobile device, we'll send a link to your phone number.",
      phoneNumberLabel: 'Phone number',
      phoneNumberError: PHONE_NUMBER_ERROR,
      button: 'Send Text',
      or: 'Or',
      logout: 'Log out',
      smsSent: 'SMS sent to your phone.',
    },
    desktopScan: {
      title: 'Scan QR code',
      subtitle:
        'Start verification by scanning the QR code on your mobile device',
    },
    review: {
      title: 'Reviewing application',
      subtitle:
        'We typically take 3-5 business days to review your application. Check your email for updates.',
      button: 'Log out',
    },
    cameraPermissionDisabled: {
      heading: 'Camera access required',
      bullets: {
        one: 'Go to your device Settings',
        two: 'Find Varo and enable Camera access',
      },
      buttons: {
        openSettings: 'Open Settings',
      },
    },
  },
  eddQuestions: {
    title: 'Banking for the way you live.',
    subTitle:
      'Please answer two questions to help us keep your account secure.',
    questionSubTitle: 'Make at least one selection.',
    buttons: { next: 'Next', logOut: 'Log out' },
    errorMessage: 'Something went wrong, please try later.',
  },
  onboarding: {
    skip: 'Skip video',
  },
  verifyEmailCode: {
    header: 'Enter verification code',
    description: 'Click on the link we sent to your email at ',
    subDescription: 'You can find your verification code in the same email.',
    buttons: {
      resend: 'Resend a new code',
    },
    newCodeSent: 'New code sent.',
  },
  verifyPhoneNumber: {
    header: 'Did you get our text?',
    description:
      'Enter the code from our text to verify your number ending in ',
    buttons: {
      resend: 'Resend code ',
    },
    emailCodeVerification: {
      header: 'Enter verification code',
      description: 'Click on the link we sent to your email at ',
      subDescription: 'You can find your verification code in the same email.',
      buttons: {
        resend: 'Resend a new code',
      },
    },
    newCodeSent: 'New code sent.',
  },
  verifyEmail: {
    header: 'We sent you an email',
    subHeader: 'Click on the link we sent to your email at ',
    description:
      'You can also verify your email with the code provided in the email we sent you  ',
    hyperlink: 'Enter Code',
    buttons: {
      resend: 'Resend link ',
    },
    toast: 'New link sent to your email',
  },
  verifyDevice: {
    header: 'For your security, we need to verify its you.',
    description: 'Enter code sent to your phone number ending in ',
    buttons: {
      resend: 'Resend code ',
    },
    toast: 'New code sent',
    emailCodeVerification: {
      header: 'Enter verification code',
      description: 'Click on the link we sent to your email at ',
      subDescription: 'You can find your verification code in the same email.',
      buttons: {
        resend: 'Resend a new code',
      },
    },
  },
  challenges: {
    genericError: 'Something went wrong. Please try again later.',
  },
  loadingScreen: {
    title: 'Hang tight',
    description: 'Securely processing your application',
  },
};

export default signupStrings;
